import React from 'react';
import Icon from '../../../components/AppIcon';
import QuickActions from '../components/QuickActions';
import { useAuth } from 'context/AuthContext';

const chaptersData = [
  {
    id: 1,
    title: "Introduction t o AI",
    description: "Explore the fundamentals of artificial intelligence, its history, and core concepts that form the foundation of modern AI systems.",
    status: "completed",
    progress: 100,
    lessons: 5,
    duration: "45 min",
    quizScore: 85,
    estimatedTime: "45 minutes"
  },
  {
    id: 2,
    title: "Machine Learning Basics",
    description: "Dive into machine learning algorithms, supervised and unsupervised learning, and understand how machines learn from data.",
    status: "current",
    progress: 60,
    lessons: 7,
    duration: "60 min",
    quizScore: null,
    estimatedTime: "60 minutes"
  },
  {
    id: 3,
    title: "AI Ethics & Future",
    description: "Examine the ethical implications of AI, bias in algorithms, and explore the future possibilities and challenges of artificial intelligence.",
    status: "current",
    progress: 0,
    lessons: 6,
    duration: "50 min",
    quizScore: null,
    estimatedTime: "50 minutes"
  },
  {
    id: 4,
    title: "AI Ethics & Future",
    description: "Examine the ethical implications of AI, bias in algorithms, and explore the future possibilities and challenges of artificial intelligence.",
    status: "locked",
    progress: 0,
    lessons: 6,
    duration: "50 min",
    quizScore: null,
    estimatedTime: "50 minutes"
  }
];


const WelcomeHeader = ({
  currentTime = new Date(),
  className = ""
}) => {
  const { user } = useAuth();
  const getGreeting = () => {
    const hour = currentTime.getHours();
    if (hour < 12) return "Good morning";
    if (hour < 17) return "Good afternoon";
    return "Good evening";
  };

  const getMotivationalMessage = () => {
    const messages = [
      "Ready to explore the world of AI?",
      "Let\'s continue your AI learning journey!",
      "Time to unlock new AI concepts!",
      "Your next breakthrough awaits!",
      "Every expert was once a beginner!"
    ];
    return messages[Math.floor(Math.random() * messages.length)];
  };

  const handleContinueLearning = () => {
    const currentChapter = chaptersData.find(chapter => chapter.status === 'current');
    if (currentChapter) {
      navigate('/interactive-presentation-viewer', {
        state: { chapterId: currentChapter.id, mode: 'continue' }
      });
    }
  };

  const handleViewProgress = () => {
    navigate('/learning-progress-tracker');
  };

  const handleTakeQuiz = () => {
    const currentChapter = chaptersData.find(chapter => chapter.status === 'current');
    if (currentChapter) {
      navigate('/quiz-assessment-interface', {
        state: { chapterId: currentChapter.id }
      });
    }
  };

  const hasActiveChapter = chaptersData.some(chapter => chapter.status === 'current');


  return (
    <div className={`bg-gradient-to-r from-primary to-secondary rounded-xl text-white p-6 ${className}`}>
      <div className="flex flex-wrap items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center mb-2 space-x-2">
            <Icon name="Sparkles" size={20} color="white" strokeWidth={2} />
            <span className="text-sm font-medium opacity-90">
              {getGreeting()}, {user?.name}!
            </span>
          </div>

          <h1 className="mb-2 text-2xl font-bold sm:text-3xl font-heading">
            Welcome back to AI Learning Hub
          </h1>

          <p className="mb-4 text-sm sm:text-base opacity-90">
            {getMotivationalMessage()}
          </p>

          <div className="flex items-center space-x-4 text-sm opacity-80">
            <div className="flex items-center space-x-1">
              <Icon name="Calendar" size={14} color="white" strokeWidth={2} />
              <span>{currentTime.toLocaleDateString('en-US', {
                weekday: 'long',
                month: 'short',
                day: 'numeric'
              })}</span>
            </div>

            <div className="flex items-center space-x-1">
              <Icon name="Clock" size={14} color="white" strokeWidth={2} />
              <span>{currentTime.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
              })}</span>
            </div>
          </div>
        </div>

        <div className="flex-wrap items-center justify-center">
          <QuickActions
            onContinueLearning={handleContinueLearning}
            onViewProgress={handleViewProgress}
            onTakeQuiz={handleTakeQuiz}
            hasActiveChapter={hasActiveChapter}
          />
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;